module.exports = __webpack_public_path__ + "img/13.1190d0fe.png";